import { Reveal, Overline } from "./Reveal";
import { STRENGTHS } from "../../data/content";

export const Manifesto = () => (
  <section id="principles" className="relative bg-[#0c2c20] py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="mb-20 max-w-3xl">
        <Overline>06 — Professional Strengths</Overline>
        <h2 className="mt-6 font-display text-4xl font-bold leading-[1.05] text-white sm:text-5xl lg:text-6xl">
          The principles behind
          <br />
          the performance
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-x-16">
        {STRENGTHS.map((s, i) => (
          <Reveal key={i} delay={0.05 * (i % 2)}>
            <div
              data-testid={`strength-${i}`}
              className="group flex gap-6 border-b border-white/10 py-9"
            >
              <span className="font-serif-e text-6xl italic leading-none text-white/10 transition-colors duration-500 group-hover:text-[#c9a24e]/70 md:text-7xl">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="pt-2">
                <h3 className="font-display text-xl font-bold text-white md:text-2xl">
                  {s.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#a1a1aa]">{s.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
